import { useState } from 'react';
import { InterestAccountTransaction, InterestAccountTransactionsRequest } from 'vopay';
import { api } from '@/services/api.config';

export default function useFetchInterestAccountTransactions() {
  const [interestAccountTransactions, setInterestAccountTransactions] = useState<InterestAccountTransaction[]>([]);
  const [total, setTotal] = useState(0);
  const [fetching, setFetching] = useState(false);

  async function fetchInterestAccountTransactions(request: InterestAccountTransactionsRequest = {}) {
    try {
      setFetching(true);
      const res = await api.fetchInterestAccountTransactions(request);

      if (!res.Success) throw new Error(res.ErrorMessage);

      setInterestAccountTransactions(res.InterestAccountTransactions);
      setTotal(res.PaginationMetaData.TotalRecords);

      return res.InterestAccountTransactions;
    } catch (err) {
      console.error(err);

      throw err;
    } finally {
      setFetching(false);
    }
  }

  return {
    interestAccountTransactions,
    fetchingInterestAccountTransactions: fetching,
    fetchInterestAccountTransactions,
    total,
  };
}
